import PropTypes from "prop-types"

import StatCard from "./../stat_card"
import Tooltip from "./../tooltip"
import { calculateChangeRate } from "./../lib"

const ServiceStats = ({
  data,
  timePeriodInDays,
  url,
  onDetailSelect,
  serviceName,
}) => (
  <div className="service-detail">
    <header
      className="service-header"
      style={{
        backgroundColor: `#${data.channel.brand_color}`,
      }}
    >
      <img src={data.channel.monochrome_image_url} alt={data.channel.name} />
      <div className="content">
        <p className="service-names">{data.channel.name}</p>
      </div>
      <div className="tooltip-container">
        <Tooltip
          content={`Connections and engagements of ${serviceName} users with ${data.channel.name} in the last ${timePeriodInDays} days`}
          isWhite={true}
        />
      </div>
    </header>
    <div className="service-body">
      <div className="service-stats">
        <div className="active-users">
          <StatCard
            statText={`Users with enabled Applets in last ${timePeriodInDays} days`}
            stat={data.activeUsers}
            changeRate={calculateChangeRate(
              data.activeUsers,
              data.activeUsersLastPeriod
            )}
            className="inline"
            timePeriodInDays={timePeriodInDays}
            compactThreshold={99999}
          />
        </div>
        <div className="service-engagement">
          <StatCard
            statText={"Service engagements"}
            stat={data.engagement}
            changeRate={calculateChangeRate(
              data.engagement,
              data.engagementLastPeriod
            )}
            className="inline"
            timePeriodInDays={timePeriodInDays}
            compactThreshold={99999}
          />
        </div>
      </div>
      <div className="bottom-button">
        <a
          role="button"
          className="button-secondary button-outlined"
          href={url}
          onClick={e => {
            if (onDetailSelect) {
              e.preventDefault()
              onDetailSelect(data.channel.module_name)
            }
          }}
        >
          View more detail
        </a>
      </div>
    </div>
  </div>
)

ServiceStats.propTypes = {
  data: PropTypes.object.isRequired,
  serviceName: PropTypes.string.isRequired,
  timePeriodInDays: PropTypes.number.isRequired,
  url: PropTypes.string,
  onDetailSelect: PropTypes.func,
}

export default ServiceStats
